<template>
	<section class="small-12 flex supportCategories animated fadeIn justify-center">
        <div class="small-12 sectionTitle flex justify-center">
            <h2>Categories</h2>
        </div>
        <ul class="float-left small-12 large-9 flex">
            <li class="small-12 large-4 columns" v-for="(article, index) in 9" :key="index">
                <router-link :to="{ name: 'HelpCategory', params: { slug: 'example-category' } }" class="small-12 flex">
                    <h6 class="small-12">
                        Getting Started
                    </h6>
                    <p class="small-12">
                        We're not going to tell you what they should be, but we'll 
                        tell you all about making them.
                    </p>
                    <span class="flex auto">9 articles</span>
                </router-link>
            </li>
        </ul>
    </section>
</template>

<script>

	// Import firebase
	import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'SupportCategories',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			prop_name_here: {

				immediate: true, // Load on created
				handler(value) {

					//

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>